import { CreatePriceGuardrail, PriceGuardrail } from '../stores/types/priceGuardrails.interface';
import { API_KEYS, Api } from './base.api';

export const priceGuardrailsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchPriceGuardrails: builder.query<PriceGuardrail[], void>({
      query: () => ({
        url: `/internal/core/v2/${API_KEYS.PRICE_RULE_GUARDRAILS}/`,
        method: 'GET',
      }),
      providesTags: [API_KEYS.PRICE_RULE_GUARDRAILS],
    }),
    createPriceGuardrail: builder.mutation<PriceGuardrail, CreatePriceGuardrail>({
      query: (body) => ({
        url: `/internal/core/v2/${API_KEYS.PRICE_RULE_GUARDRAILS}/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [API_KEYS.PRICE_RULE_GUARDRAILS],
    }),
    updatePriceGuardrail: builder.mutation<PriceGuardrail, PriceGuardrail>({
      query: (guardrail) => {
        const { id, ...body } = guardrail;
        return {
          url: `/internal/core/v2/${API_KEYS.PRICE_RULE_GUARDRAILS}/${id}`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: [API_KEYS.PRICE_RULE_GUARDRAILS],
    }),
    deletePriceGuardrail: builder.mutation<void, string>({
      query: (id) => ({
        url: `/internal/core/v2/${API_KEYS.PRICE_RULE_GUARDRAILS}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [API_KEYS.PRICE_RULE_GUARDRAILS],
    }),
    checkChargerPriceRuleGuardrails: builder.mutation<
      { guardrails: Record<string, PriceGuardrail[]> },
      { deviceIds: string[] }
    >({
      query: ({ deviceIds }) => ({
        url: `/internal/core/v2/${API_KEYS.CHARGERS}/priceRuleGuardrails/check`,
        method: 'POST',
        body: { deviceIds },
      }),
    }),
  }),
});

export const {
  useFetchPriceGuardrailsQuery,
  useCreatePriceGuardrailMutation,
  useUpdatePriceGuardrailMutation,
  useDeletePriceGuardrailMutation,
  useCheckChargerPriceRuleGuardrailsMutation,
} = priceGuardrailsApi;
